import { render, staticRenderFns } from "./ShiftSelect.vue?vue&type=template&id=36dec518&scoped=true"
import script from "./ShiftSelect.vue?vue&type=script&lang=js"
export * from "./ShiftSelect.vue?vue&type=script&lang=js"
import style0 from "./ShiftSelect.vue?vue&type=style&index=0&id=36dec518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dec518",
  null
  
)

export default component.exports